(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.WishlistManager) {
      if (typeof window.WishlistManager.refresh === 'function') {
        window.WishlistManager.refresh();
      }
      return;
    }

    class WishlistManager {
      constructor() {
        this.storageKey = 'marine_patches_wishlist';
        this.state = this.load();
        this.bindEvents();
        this.updateAll();
        window.addEventListener('storage', (event) => {
          if (event.key !== this.storageKey) return;
          this.state = this.load();
          this.updateAll();
        });
      }

      load() {
        try {
          const raw = localStorage.getItem(this.storageKey);
          const parsed = raw ? JSON.parse(raw) : null;
          if (parsed && Array.isArray(parsed.items)) {
            return parsed;
          }
        } catch (error) {
          return { items: [] };
        }
        return { items: [] };
      }

      save() {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(this.state));
        } catch (error) {
          return;
        }
      }

      normalizeId(id) {
        if (id === null || id === undefined || id === '') return null;
        const asNumber = Number(id);
        if (Number.isNaN(asNumber)) return String(id);
        return String(asNumber);
      }

      getItems() {
        return Array.isArray(this.state.items) ? this.state.items : [];
      }

      isInWishlist(id) {
        const key = this.normalizeId(id);
        if (!key) return false;
        return this.getItems().some((item) => this.normalizeId(item.id) === key);
      }

      addItem(item) {
        const key = this.normalizeId(item.id);
        if (!key || this.isInWishlist(key)) return false;
        const payload = {
          id: key,
          handle: item.handle || '',
          title: item.title || '',
          price: item.price || '',
          image: item.image || '',
          url: item.url || '',
          added_at: new Date().toISOString(),
        };
        this.state.items = [...this.getItems(), payload];
        this.save();
        this.dispatch('wishlist:added', payload);
        this.dispatch('wishlist:updated', { items: this.state.items });
        this.updateAll();
        return true;
      }

      removeItem(id) {
        const key = this.normalizeId(id);
        if (!key) return false;
        const items = this.getItems();
        const next = items.filter((item) => this.normalizeId(item.id) !== key);
        if (next.length === items.length) return false;
        this.state.items = next;
        this.save();
        this.dispatch('wishlist:removed', { id: key });
        this.dispatch('wishlist:updated', { items: next });
        this.updateAll();
        return true;
      }

      toggleItem(item) {
        if (this.isInWishlist(item.id)) {
          return this.removeItem(item.id);
        }
        return this.addItem(item);
      }

      getCount() {
        return this.getItems().length;
      }

      dispatch(name, detail) {
        document.dispatchEvent(new CustomEvent(name, { detail }));
      }

      getProductData(button) {
        return {
          id: button.dataset.productId,
          handle: button.dataset.productHandle,
          title: button.dataset.productTitle,
          price: button.dataset.productPrice,
          image: button.dataset.productImage,
          url: button.dataset.productUrl,
        };
      }

      bindEvents() {
        document.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-wishlist-button]');
            if (!button) return;
            event.preventDefault();
            event.stopPropagation();
            const data = this.getProductData(button);
            if (!data.id) return;
            this.toggleItem(data);
          },
          true
        );
      }

      updateButtons() {
        const buttons = document.querySelectorAll('[data-wishlist-button]');
        buttons.forEach((button) => {
          const isActive = this.isInWishlist(button.dataset.productId);
          button.classList.toggle('is-active', isActive);
          const addLabel = button.dataset.wishlistAddLabel || button.getAttribute('aria-label') || '';
          const removeLabel = button.dataset.wishlistRemoveLabel || addLabel;
          button.setAttribute('aria-label', isActive ? removeLabel : addLabel);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      updateCounts() {
        const count = this.getCount();
        document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
          badge.textContent = String(count);
          badge.hidden = count < 1;
        });
        document.querySelectorAll('[data-wishlist-toggle]').forEach((toggle) => {
          const label = toggle.dataset.wishlistLabel || toggle.getAttribute('aria-label') || '';
          toggle.setAttribute('aria-label', count > 0 ? `${label} (${count})` : label);
        });
        const pageCount = document.querySelector('[data-wishlist-page-count]');
        if (pageCount) pageCount.textContent = String(count);
      }

      updateWishlistPage() {
        const section = document.querySelector('[data-wishlist-section]');
        if (!section) return;
        const container = section.querySelector('[data-wishlist-container]');
        const emptyState = section.querySelector('[data-wishlist-empty]');
        const loadingState = section.querySelector('[data-wishlist-loading]');
        const template = section.querySelector('[data-wishlist-card-template]');
        const placeholder = section.querySelector('[data-wishlist-placeholder]');
        if (!container || !template) return;
        const items = this.getItems();
        if (loadingState) loadingState.hidden = true;
        if (items.length === 0) {
          container.hidden = true;
          if (emptyState) emptyState.hidden = false;
          return;
        }
        if (emptyState) emptyState.hidden = true;
        container.hidden = false;
        container.innerHTML = '';
        items.forEach((item) => {
          const fragment = template.content.cloneNode(true);
          const card = fragment.querySelector('[data-wishlist-card]');
          const link = fragment.querySelector('[data-wishlist-card-link]');
          const title = fragment.querySelector('[data-wishlist-card-title]');
          const price = fragment.querySelector('[data-wishlist-card-price]');
          const image = fragment.querySelector('[data-wishlist-card-image]');
          const thumbnails = fragment.querySelector('[data-wishlist-card-thumbnails]');
          const button = fragment.querySelector('[data-wishlist-button]');
          if (card) card.dataset.productId = item.id;
          if (link) {
            link.href = item.url || '#';
            link.setAttribute('aria-label', item.title || '');
          }
          if (title) title.textContent = item.title || '';
          if (price) price.textContent = item.price || '';
          if (image) {
            if (item.image) {
              const img = document.createElement('img');
              img.src = item.image;
              img.alt = item.title || '';
              img.loading = 'lazy';
              img.className = 'product-card__image';
              image.innerHTML = '';
              image.appendChild(img);
            } else if (placeholder) {
              image.innerHTML = placeholder.innerHTML;
            }
          }
          if (thumbnails) {
            thumbnails.hidden = true;
            thumbnails.innerHTML = '';
          }
          if (button) {
            button.dataset.productId = item.id;
            button.dataset.productHandle = item.handle || '';
            button.dataset.productTitle = item.title || '';
            button.dataset.productPrice = item.price || '';
            button.dataset.productImage = item.image || '';
            button.dataset.productUrl = item.url || '';
          }
          container.appendChild(fragment);

          if (image && thumbnails && item.handle) {
            this.enrichWishlistCardMedia({
              title: item.title || '',
              handle: item.handle,
              imageContainer: image,
              thumbnailsContainer: thumbnails,
              placeholder,
            });
          }
        });
        this.updateButtons();
      }

      buildSizedImageUrl(src, width) {
        if (!src) return '';
        try {
          const url = new URL(src, window.location.origin);
          url.searchParams.set('width', String(width));
          return url.toString();
        } catch (error) {
          return src;
        }
      }

      getProductJson(handle) {
        this.productCache = this.productCache || new Map();
        if (this.productCache.has(handle)) return this.productCache.get(handle);

        const request = fetch(`/products/${handle}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to load product JSON for ${handle}`);
            return response.json();
          })
          .catch(() => null);

        this.productCache.set(handle, request);
        return request;
      }

      async enrichWishlistCardMedia({ title, handle, imageContainer, thumbnailsContainer, placeholder }) {
        const product = await this.getProductJson(handle);
        if (!product || !Array.isArray(product.images) || product.images.length === 0) return;

        const alt = title || product.title || '';
        const mainTarget = imageContainer.querySelector('img.product-card__image');
        const firstImage = product.images[0];

        if (firstImage) {
          const mainSrc = this.buildSizedImageUrl(firstImage, 520);
          if (mainTarget) {
            mainTarget.src = mainSrc;
            mainTarget.alt = alt;
          } else {
            const img = document.createElement('img');
            img.src = mainSrc;
            img.alt = alt;
            img.loading = 'lazy';
            img.className = 'product-card__image';
            imageContainer.innerHTML = '';
            imageContainer.appendChild(img);
          }
        } else if (placeholder && imageContainer.childNodes.length === 0) {
          imageContainer.innerHTML = placeholder.innerHTML;
        }

        if (!thumbnailsContainer) return;
        if (product.images.length <= 1) {
          thumbnailsContainer.hidden = true;
          thumbnailsContainer.innerHTML = '';
          return;
        }

        thumbnailsContainer.hidden = false;
        thumbnailsContainer.innerHTML = '';

        product.images.forEach((src) => {
          const thumb = document.createElement('img');
          const thumbSrc = this.buildSizedImageUrl(src, 48);
          const fullSrc = this.buildSizedImageUrl(src, 520);
          const fullSrc2x = this.buildSizedImageUrl(src, 1040);

          thumb.src = thumbSrc;
          thumb.srcset = `${thumbSrc} 48w`;
          thumb.width = 48;
          thumb.height = 48;
          thumb.loading = 'lazy';
          thumb.className = 'product-card__thumb';
          thumb.alt = alt;
          thumb.dataset.fullSrc = fullSrc;
          thumb.dataset.fullSrcset = `${fullSrc} 520w, ${fullSrc2x} 1040w`;
          thumbnailsContainer.appendChild(thumb);
        });
      }

      updateAll() {
        this.updateButtons();
        this.updateCounts();
        this.updateWishlistPage();
      }

      refresh() {
        this.state = this.load();
        this.updateAll();
      }
    }

    window.WishlistManager = new WishlistManager();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-wishlist-section]');
    if (!section) return;

    const getMainImage = (card) => card.querySelector('.product-card__image');
    const normalizeSrc = (src) => (src ? src.replace(/^https?:/, '') : '');

    const getNextImage = (thumb) => {
      const fullSrc = thumb.dataset.fullSrc || thumb.currentSrc || thumb.src;
      if (!fullSrc) return null;

      return {
        src: fullSrc,
        srcset: thumb.dataset.fullSrcset || '',
        alt: thumb.alt || '',
      };
    };

    const applyLoadingState = (card, mainImage) => {
      if (!card) return () => {};

      card.classList.add('product-card--image-loading');

      const clear = () => {
        card.classList.remove('product-card--image-loading');
        mainImage.removeEventListener('load', clear);
        mainImage.removeEventListener('error', clear);
      };

      mainImage.addEventListener('load', clear);
      mainImage.addEventListener('error', clear);

      requestAnimationFrame(() => {
        if (mainImage.complete) {
          clear();
        }
      });

      return clear;
    };

    const updateMainImage = (mainImage, nextImage) => {
      mainImage.src = nextImage.src;

      if (nextImage.srcset) {
        mainImage.srcset = nextImage.srcset;
      } else {
        mainImage.removeAttribute('srcset');
      }

      if (nextImage.alt) {
        mainImage.alt = nextImage.alt;
      }
    };

    section.addEventListener(
      'click',
      (event) => {
        const thumb = event.target.closest('.product-card__thumb');
        if (!thumb || !(thumb instanceof HTMLImageElement)) return;

        const card = thumb.closest('.wishlist-card');
        if (!card) return;

        const mainImage = getMainImage(card);
        if (!mainImage) return;

        const nextImage = getNextImage(thumb);
        if (!nextImage) return;

        const currentSrc = normalizeSrc(mainImage.currentSrc || mainImage.src);
        const nextSrc = normalizeSrc(nextImage.src);

        event.preventDefault();
        event.stopPropagation();

        if (currentSrc && nextSrc && currentSrc === nextSrc) return;

        applyLoadingState(card, mainImage);
        updateMainImage(mainImage, nextImage);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
